import React from 'react';
import { useFeatureFlag } from 'signer-app/context/feature-flags';
import { SmsAuthNumber } from 'signer-app/signer-experience/sms-auth-number';
import { SmsAuthNumberV2 } from 'signer-app/signer-experience/sms-auth-number-v2';

type Props = React.ComponentProps<typeof SmsAuthNumber>;

export const SmsAuthNumberWithFlag: React.FC<Props> = (props) => {
  const smsAuthV2Enabled = useFeatureFlag(
    'sign_core_2026_06_22_sms_auth_number_v2',
  );

  if (smsAuthV2Enabled) {
    return <SmsAuthNumberV2 {...props} />;
  }

  return <SmsAuthNumber {...props} />;
};
